// import 'babel-polyfill'

import Vue from "vue";

import App from "./App.vue";
import router from "@/router";
import store from "@/store";

import "@/assets/js/velocity.min.js";
import "@/init/vuetify";
import "@/config/main.styl";
import "@/assets/css/transition/transition.css";
require("hammerjs");
Vue.config.productionTip = false;

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount("#app");
